__turbopack_context__.v({
  "className": "figtree_b3598ff4-module__E99uKG__className",
  "variable": "figtree_b3598ff4-module__E99uKG__variable",
});
